<template>
    <div>
        {{computedNextQuestion}}
        <v-dialog v-model="$store.state.showQuiz" persistent max-width="500px">
            <v-layout>
                <v-flex md12>
                    <v-card dark class="targetQuiz elevation-12" :style="{'background': $store.state.colorQuiz}" max-width="500px">
                        <v-container grid-list-md text-xs-center>
                            <v-layout column>
                                <v-layout justify-center>
                                    <p class="subtitle font-weight-black text-uppercase subtitleCategory">
                                        - {{Question.category}} -</p>
                                </v-layout>
                                <v-layout justify-center>
                                    <v-card-title>
                                        <h3 class="titleQuiz">
                                            {{Question.text}}</h3>
                                    </v-card-title>
                                </v-layout>
                                <v-flex v-for="(number,index) in numbersRandom"
                                        :key="index + Question.answers[number].text"
                                        v-on:click="result(Question.answers[number])">
                                    <v-card color="#EEEEEE" class="classAnswersQuiz">
                                        <v-card-text justify-center
                                                     v-show="Question.answers[number].text !== ''"
                                                     class="textQuiz"
                                        >
                                            {{Question.answers[number].text}}
                                        </v-card-text>
                                    </v-card>
                                </v-flex>

                                <v-progress-circular
                                        :size="50"
                                        color="amber"
                                        indeterminate
                                >
                                    <h1 id="numero">{{timeSeconds}}</h1>
                                </v-progress-circular>
                            </v-layout>
                            <v-layout justify-center>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-dialog>
        <div class="text-xs-center">
            <v-dialog
                    v-model="showCardCorrectAnswer"
                    width="500"
                    persistent
            >
                <v-layout>
                    <v-flex md12>
                        <v-card dark class="targetQuiz  elevation-12" color="green" >
                            <v-container grid-list-md text-xs-center>
                                <v-layout column>
                                    <v-flex>
                                        <v-layout justify-center>
                                            <v-card-title>
                                                <h3 class="titleQuizCorrect">{{$t('titleLaRespostaCorrectaEs')}}</h3>
                                            </v-card-title>
                                        </v-layout>
                                            <v-card-text justify-center
                                                         class="font-weight-black"
                                            >
                                                {{respostaCorrectaMostrar}}
                                            </v-card-text>
                                    </v-flex>
                                    <v-flex>
                                        <v-btn v-on:click="hideCardCorrectAnswer" outline color="white">
                                            {{$t('hideCardCorrectAnswer')}}
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-layout justify-center>
                                </v-layout>
                            </v-container>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-dialog>
        </div>
    </div>
</template>

<script>
    import VueFire from 'vuefire'
    import Vue from 'vue'
    import {db} from '../firebaseConfig'
    import 'vuejs-noty/dist/vuejs-noty.css'
    import {Trans} from '../plugins/Translation'

    import encertarPreguntaSound from '../Sounds/win_4.wav'
    import fallarPreguntaSound from '../Sounds/lost_2.mp3'
    import tempsAcabatSound from '../Sounds/tempsFinalitzat2.mp3'

    import firebase from 'firebase';

    Vue.use(VueFire);

    let questionsRef = db.ref('Questions');
    let usersRef = db.ref('Users');
    let varGame = db.ref('varGame');


    export default {
        name: "Quiz",
        firebase: {
            questionsRef,
            usersRef
        },
        props: {
            categoryName: String,
            enviarVar: Boolean,
        },
        data() {
            return {
                preguntaCorrectaMostrar: '',
                respostaCorrectaMostrar: '',
                showCardCorrectAnswer: false,
                counterGames: 0,
                //
                selectLanguage: "",
                selectCategory: "",
                respostaCorrecta: "",
                pregunta: "",
                languages: [
                    {
                        buttonSelected: true,
                        lang: 'Cat'
                    },
                    {
                        buttonSelected: false,
                        lang: 'Es'
                    },
                    {
                        buttonSelected: false,
                        lang: 'En'
                    }
                ],
                Question: {},
                numbersRandom: [],
                secondsCrono: 0,
                //temps crono
                timeSeconds: null,
                stop: 1,
                sumarPunts: 0,
                restarPunts: 0,
                contadorPreguntesCorrect: 0,
                contadorPreguntesFailed: 0,
                contadorTotalPunts: 0,
                contadorPreguntesCorrectGame: 0,
                contadorPreguntesFailedGame: 0,
                cancelCrono: null,
                dialog: false,
            }
        },
        created() {
            varGame.child('timeSeconds').on('value', snap => this.timeSeconds = snap.val());

            if (Trans.currentLanguage === 'cat') {
                this.selectLanguage = "Cat"
            }
            if (Trans.currentLanguage === 'es') {
                this.selectLanguage = "Es"
            }

            // control idioma al recarregar
            let lang;
            let path = window.location.pathname;

            if (path === '/jocPadro/cat/board') {
                lang = 'cat';
                this.selectLanguage = "Cat"
            } else if (path === '/jocPadro/es/board') {
                lang = 'es';
                this.selectLanguage = "Es"
            }
            const to = this.$router.resolve({params: {lang}});
            return Trans.changeLanguage(lang).then(() => {
                this.$router.push(to.location);
            });

        },
        methods: {
            nextQuestion() {

                this.random();
                let num = Math.floor(Math.random() * this.questionsRef.length);

                if (this.questionsRef[num].category === this.categoryName) {
                    this.Question = {
                        id: this.questionsRef[num]['.key'],
                        img: this.questionsRef[num].img,
                        category: this.questionsRef[num].category,
                        lang: this.selectLanguage,
                        text: this.questionsRef[num][this.selectLanguage].text,
                        answers: [
                            {text: this.questionsRef[num][this.selectLanguage].correctAnswer, correct: true},
                            {text: this.questionsRef[num][this.selectLanguage].answer3, correct: false},
                            {text: this.questionsRef[num][this.selectLanguage].answer1, correct: false},
                            {text: this.questionsRef[num][this.selectLanguage].answer2, correct: false}
                        ],
                    };
                    //guardar la pregunta correcte en una variable
                    this.respostaCorrectaMostrar = this.questionsRef[num][this.selectLanguage].correctAnswer;
                    this.preguntaCorrectaMostrar = this.questionsRef[num][this.selectLanguage].text;

                    //mostrar la resposta correcte
                    // console.log("CORRECTE: " + this.questionsRef[num][this.selectLanguage].correctAnswer);
                } else {
                    this.nextQuestion();
                }
                this.$emit('nextQuestionChild', this.Question);


            },
            random() {
                let j, k;

                this.numbersRandom = [0, 1, 2, 3];

                for (let i = this.numbersRandom.length; i; i--) {

                    j = Math.floor(Math.random() * i);
                    k = this.numbersRandom[i - 1];
                    this.numbersRandom[i - 1] = this.numbersRandom[j];
                    this.numbersRandom[j] = k;
                }

            },
            result(number) {
                //number = pregunta (conté text i si es correcte)
                this.$emit('resultQuestionChild', number);

                let this2 = this;


                //sumar o restar punts
                if (number.correct === true) {

                    //sound
                    let encertarPreguntaSong = new Audio(encertarPreguntaSound);
                    encertarPreguntaSong.play();

                    firebase.auth().onAuthStateChanged(function (user) {
                        this2.sumarPunts = this2.sumarPunts + 10;

                        //contador de preguntes correctes per usuari
                        usersRef.child(user.uid).child('numberCorrectAnswers').on('value', snap => this2.contadorPreguntesCorrect = snap.val());
                        this2.contadorPreguntesCorrect = this2.contadorPreguntesCorrect + 1;

                        //sumar les preguntes encertades per partida
                        this2.contadorPreguntesCorrectGame = this2.contadorPreguntesCorrectGame + 1;

                        //score sumar
                        usersRef.child(user.uid).child('score').on('value', snap => this2.contadorTotalPunts = snap.val());
                        this2.contadorTotalPunts = this2.contadorTotalPunts + 10;

                        let updates = {};
                        updates['Users/' + user.uid + '/' + 'pointsCorrectGame'] = this2.sumarPunts;
                        updates['Users/' + user.uid + '/' + 'numberCorrectAnswers'] = this2.contadorPreguntesCorrect;
                        updates['Users/' + user.uid + '/' + 'score'] = this2.contadorTotalPunts;
                        updates['Users/' + user.uid + '/' + 'numberCorrectAnswersGame'] = this2.contadorPreguntesCorrectGame;
                        return firebase.database().ref().update(updates);
                    });

                    this2.$store.commit('showQuizFalse');
                    this2.secondsCrono = 0;
                    this2.cancelCrono = true;


                } else {
                    //sound
                    let fallataPreguntaSong = new Audio(fallarPreguntaSound);
                    fallataPreguntaSong.play();


                    //mostrar la finestra on s'ensenya la resposta correcta
                    setTimeout(() => {
                        this.showCardCorrectAnswer = true;
                    },800);


                    firebase.auth().onAuthStateChanged(function (user) {
                        this2.restarPunts = this2.restarPunts + 5;

                        //contador de preguntes fallades per usuari
                        usersRef.child(user.uid).child('numberFailedAnswers').on('value', snap => this2.contadorPreguntesFailed = snap.val());
                        this2.contadorPreguntesFailed = this2.contadorPreguntesFailed + 1;

                        //sumar les preguntes fallades per partida
                        this2.contadorPreguntesFailedGame = this2.contadorPreguntesFailedGame + 1;

                        //score restar
                        usersRef.child(user.uid).child('score').on('value', snap => this2.contadorTotalPunts = snap.val());
                        this2.contadorTotalPunts = this2.contadorTotalPunts - 5;

                        let updates = {};
                        updates['Users/' + user.uid + '/' + 'pointsFailedGame'] = this2.restarPunts;
                        updates['Users/' + user.uid + '/' + 'numberFailedAnswers'] = this2.contadorPreguntesFailed;
                        updates['Users/' + user.uid + '/' + 'score'] = this2.contadorTotalPunts;
                        updates['Users/' + user.uid + '/' + 'numberFailedAnswersGame'] = this2.contadorPreguntesFailedGame;

                        return firebase.database().ref().update(updates);
                    });
                    this2.$store.commit('showQuizFalse');
                    this2.secondsCrono = 0;
                    this2.cancelCrono = true;
                }

                this.$store.commit('changeCanMoveDiceTrue');

            },
            crono() {
                let this2 = this;
                this2.secondsCrono = this.timeSeconds;
                this2.cancelCrono = false;

                let inter = setInterval(function () {
                    document.getElementById('numero').innerHTML = this2.secondsCrono.toString();
                    this2.secondsCrono--;
                    if (this2.secondsCrono < 0) {
                        clearInterval(inter);
                        this2.$store.commit('showQuizFalse');
                        this2.secondsCrono = this2.timeSeconds;
                        document.getElementById('numero').innerHTML = this2.secondsCrono.toString();
                    }
                }, 1000);
            },
            hideCardCorrectAnswer() {
                this.showCardCorrectAnswer = false;
            }
        },
        computed: {
            computedNextQuestion() {
                //carregar les preguntes nomes si l'estat es true i la finestra esta oberta
                //category != "" perque Quiz tarda un segon en rebre la categoria seleccionada del Board
                if (this.$store.state.showQuiz === true && this.categoryName !== "") {
                    this.nextQuestion();
                    this.crono();
                }

                //quant la finestra de quiz esta amagada es mostra l'animacio i la imatge de TEMPS acabat
                if (this.$store.state.showQuiz === false && this.cancelCrono === false) {
                    this.$store.commit('showFinishTimeImgTrue');

                    let tempsAcabatSong = new Audio(tempsAcabatSound);

                    tempsAcabatSong.play();


                    setTimeout(() => {
                        this.$store.commit('showFinishTimeImgFalse');
                        tempsAcabatSong.pause();
                    }, 2000)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    * {
        margin-top: 0;
    }

    .classAnswersQuiz{
        border-radius: 20px;
    }

    .titleQuizCorrect{
        color: white;
        font-family: 'Roboto', sans-serif;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 24px;
    }

    .titleQuiz{
        color: dimgray;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 20px;
        word-break: normal;
    }

    .textQuiz{
        color: dimgray !important;
    }

    .targetQuiz {
        position: relative;

        border-radius: 20px;
        overflow: hidden;
    }

    .targetQuiz::before {
        content: '';
        margin: -35px;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        filter: blur(20px);
        z-index: -1;
    }

    .subtitleCategory {
        width: 110%;
        color: dimgray;
        /*text-shadow: 0px 2px 2px #888888;*/
        font-size: 30px;
    }

    /*.dice0 {*/
    /*border: solid 3px #aaa;*/
    /*border-radius: 3px;*/
    /*display: block;*/
    /*width: 100px;*/
    /*height: 100px;*/
    /*margin: 7px auto;*/
    /*box-sizing: border-box;*/
    /*padding: 10px;*/
    /*position: relative;*/

    /*.dot {*/
    /*border-radius: 50%;*/
    /*position: absolute;*/
    /*width: 15px;*/
    /*height: 15px;*/
    /*background: #000;*/
    /*}*/
    /*}*/


</style>
